import {Component, Input} from "@angular/core";

@Component({
    selector: "wbo-edit-grid-cancel-action",
    styleUrls: ["./edit-grid-cancel-action.component.scss"],
    templateUrl: "./edit-grid-cancel-action.component.html"
})
export class EditGridCancelActionComponent {
    @Input() title: string;
}
